import React from "react"
import Image from "gatsby-image"
import styled from "styled-components"
import { Row, Col } from "react-bootstrap"

let SpeakersRowSix = props => {
  return (
    <>
      <section style={{}}>
        <Row>
          <BtnGo href="#section-donate">Ver webinar</BtnGo>
        </Row>
        <Row style={{ justifyContent: "center" }}>
          <Title>Speakers</Title>
        </Row>
        <Row style={{ justifyContent: "center" }}>
          <SubTitle>
            Comparte junto a{" "}
            <spam style={{ fontWeight: "bold" }}>4 ponentes</spam> las
            experiencias <br></br> de la implementación de esta potente
            herramienta de gestión estratégica.
          </SubTitle>
        </Row>
        <RowSpeakers className="row">
          <DivSpeakers className="col-xl-3 col-lg-6 col-md-6 col-sm-6">
            <Image
              fluid={props.fluidSpeakerOne}
              alt={props.nameSpeakerOne}
            ></Image>
            <h4>{props.nameSpeakerOne}</h4>
            <div style={{ height: "11rem" }}>
              <p style={{ fontWeight: "bold" }}>{props.jobSpeakerOne}</p>
              <p style={{ fontSize: "1rem" }}>{props.companySpeakerOne}</p>
            </div>
            <a href={props.linkSpeakerOne}>
              <Image
                fluid={props.LinkIcon}
                style={{
                  width: "50px",
                  margin: "auto",
                  marginTop: "1rem",
                }}
                alt={props.nameSpeakerOne}
              ></Image>
            </a>
          </DivSpeakers>

          <DivSpeakers className="col-xl-3 col-lg-6 col-md-6 col-sm-6">
            <Image
              fluid={props.fluidSpeakerTwo}
              alt={props.nameSpeakerTwo}
            ></Image>
            <h4>{props.nameSpeakerTwo}</h4>
            <div style={{ height: "11rem" }}>
              <p style={{ fontWeight: "bold" }}>{props.jobSpeakerTwo}</p>
              <p style={{ fontSize: "1rem" }}>{props.companySpeakerTwo}</p>
            </div>
            <a href={props.linkSpeakerTwo}>
              <Image
                fluid={props.LinkIcon}
                style={{
                  width: "50px",
                  margin: "auto",
                  marginTop: "1rem",
                }}
                alt={props.nameSpeakerTwo}
              ></Image>
            </a>
          </DivSpeakers>

          <DivSpeakers className="col-xl-3 col-lg-6 col-md-6 col-sm-6">
            <Image
              fluid={props.fluidSpeakerThree}
              alt={props.nameSpeakerThree}
            ></Image>
            <h4>{props.nameSpeakerThree}</h4>
            <div style={{ height: "11rem" }}>
              <p style={{ fontWeight: "bold" }}>{props.jobSpeakerThree}</p>
              <p style={{ fontSize: "1rem" }}>{props.companySpeakerThree}</p>
            </div>
            <a href={props.linkSpeakerThree}>
              <Image
                fluid={props.LinkIcon}
                style={{
                  width: "50px",
                  margin: "auto",
                  marginTop: "1rem",
                }}
                alt={props.nameSpeakerThree}
              ></Image>
            </a>
          </DivSpeakers>

          <DivSpeakers className="col-xl-3 col-lg-6 col-md-6 col-sm-6">
            <Image
              fluid={props.fluidSpeakerFour}
              alt={props.nameSpeakerFour}
            ></Image>
            <h4>{props.nameSpeakerFour}</h4>
            <div style={{ height: "11rem" }}>
              <p style={{ fontWeight: "bold" }}>{props.jobSpeakerFour}</p>
              <p style={{ fontSize: "1rem" }}>{props.companySpeakerFour}</p>
            </div>
            {/*   <a href={props.linkSpeakerFour}>
              <Image
                fluid={props.LinkIcon}
                style={{
                  width: "50px",
                  margin: "auto",
                  marginTop: "1rem",
                }}
                alt={props.nameSpeakerFour}
              ></Image>
            </a> */}
          </DivSpeakers>
        </RowSpeakers>
        <Row style={{ justifyContent: "center" }}>
          <Title>Experiencia CleverIT</Title>
        </Row>
        <Row style={{ justifyContent: "center" }}>
          <SubTitle>
            Conoce la experiencia de CleverIT <br></br>implementando un proyecto
            de agilidad usando OKR.
          </SubTitle>
        </Row>
        <Row
          style={{
            justifyContent: "center",
          }}
        >
          {props.nameSpeakerFive && (
            <DivSpeakers className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
              <Image
                fluid={props.fluidSpeakerFive}
                alt={props.nameSpeakerFive}
              ></Image>
              <h4>{props.nameSpeakerFive}</h4>
              <p style={{ fontWeight: "bold" }}>{props.jobSpeakerFive}</p>
              <p style={{ fontSize: "1rem" }}>{props.companySpeakerFive}</p>
              <a href={props.linkSpeakerFive}>
                <Image
                  fluid={props.LinkIcon}
                  style={{
                    width: "50px",
                    margin: "auto",
                    marginTop: "1rem",
                  }}
                  alt={props.nameSpeakerFive}
                ></Image>
              </a>
            </DivSpeakers>
          )}
          {props.nameSpeakerSix && (
            <DivSpeakers className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
              <Image
                fluid={props.fluidSpeakerSix}
                alt={props.nameSpeakerSix}
                class="img-fluid"
              ></Image>
              <h4>{props.nameSpeakerSix}</h4>
              <p style={{ fontWeight: "bold" }}>{props.jobSpeakerSix}</p>
              <p style={{ fontSize: "1rem" }}>{props.companySpeakerSix}</p>
              <a href={props.linkSpeakerSix}>
                <Image
                  fluid={props.LinkIcon}
                  style={{
                    width: "50px",
                    margin: "auto",
                    marginTop: "1rem",
                  }}
                  alt={props.nameSpeakerSix}
                ></Image>
              </a>
            </DivSpeakers>
          )}
        </Row>
      </section>
    </>
  )
}

export default SpeakersRowSix

const RowSpeakers = styled.div`
  margin-left: auto;
  margin-right: auto;
  max-width: 80%;
  margin-top: 3rem;
  @media (max-width: 400px) {
    margin-top: 1rem;
  }
`

const DivSpeakers = styled.div`
  text-align: center;
  margin-bottom: 2rem;
  height: 400px /* max-height: 200px; */ h4 {
    margin-top: 1rem;
    margin-bottom: 1rem;
    font-weight: bold;
  }
  p {
    margin: 0;
    font-size: 1.2rem;
    color: #414141;
  }
`
const Title = styled.h2`
  font-family: "Open Sans", sans-serif;
  font-weight: 700;
  line-height: 1.2;
  padding-top: 2rem;
  padding-bottom: 3rem;
  font-size: 3rem;
  text-align: center;
  margin-top: 4rem;
  @media (max-width: 600px) {
    font-size: 2rem;
    padding-bottom: 2rem;
  }
  @media (max-width: 400px) {
    font-size: 1.3rem;
    margin-top: 2rem;
    padding-bottom: 1rem;
  }
`
const SubTitle = styled.h4`
  font-family: "Open Sans", sans-serif;
  text-align: center;
  margin-bottom: 4rem;
  color: #414141;
  @media (max-width: 600px) {
    font-size: 1.3rem;
    padding-left: 2rem;
    padding-right: 2rem;
  }
`
const BtnGo = styled.a`
  background-color: #00bf8c !important;
  padding: 1rem 2rem 1rem 2rem;
  border-radius: 6px;
  border-width: 0;
  margin-left: auto;
  margin-right: auto;
  text-decoration: none;
  color: white;
  font-size: 1.3rem !important;
  :active {
    background-color: #00bf8c !important;
  }
  :hover {
    background-color: #00bf8c !important;
    text-decoration: none;
  }
  :visited {
    background-color: #00bf8c !important;
  }
  :link {
    background-color: #00bf8c !important;
  }
`
